import React, { useEffect, useState } from "react";

import { Box, Typography, Button } from "@mui/material";
import YourGuide from "../../assets/media/your-guide.jpg";
import { useNavigate } from "react-router-dom";
import { getCategories } from "../../api/admin/service-management";

export default function SeventhSectionHome({ categories }: { categories: any[] }) {
  const [serviceIds, setServiceIds] = useState([]);
  const navigate = useNavigate();

  const buildServicesState = (ids = []) => {
    return ids.reduce((acc, id) => {
      if (id && Number(id)) {
        acc[Number(id)] = true;
      }
      return acc;
    }, {});
  };

  const handleStartPlanningToday = () => {
    const servicesState = buildServicesState(serviceIds);

    navigate("/home/list-of-funeral-homes/", {
      state: {
        needType: "preneed",
        services: servicesState,
      },
    });
  };


  useEffect(() => {
    if (categories && categories.length > 0) {
      const preNeedCategories = categories.filter((cat: any) =>
        cat.needTypes?.includes("pre_need"),
      );
      const ids = preNeedCategories.map((item: any) => item.id);
      setServiceIds(ids);
    }
  }, [categories]);


  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: { xs: "column", md: "row" },
        height: { xs: "auto", md: "70vh" },
        width: "100%",
        overflowX: "hidden",
      }}
    >
      {/* Left Section */}
      <Box
        sx={{
          width: { xs: "100%", md: "50%" },
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          px: { xs: 4, sm: 6, md: 10 },
          pt: { xs: 4, md: 8 },
          pb: { xs: 3, md: 0 },
          boxSizing: "border-box",
        }}
      >
        <Box
          sx={{
            textAlign: { xs: "center", md: "left" },
            paddingLeft: { xs: 0, md: "2rem" },
            maxWidth: "100%",
            width: "100%",
            boxSizing: "border-box",
          }}
        >
          <Typography
            sx={{
              fontWeight: 400,
              fontSize: { xs: "24px", sm: "36px", md: "59px" },
              lineHeight: "1.2",
              color: "#104145",
              mb: 3,
              wordBreak: "break-word",
              width: "100%",
            }}
          >
            Guidance{" "}
            <span style={{ color: "#9F7F2C" }}>You Can Rely On</span>
          </Typography>

          <Typography
            sx={{
              fontWeight: 400,
              fontSize: { xs: "14px", sm: "18px", md: "24px" },
              lineHeight: "1.4",
              color: "#104145",
              mb: 4,
              wordBreak: "break-word",
              width: "100%",
            }}
          >
            From first questions through the decisions ahead, MemorialGo offers
            guidance, helpful tools, and trusted options.
          </Typography>

          <Button
            variant="contained"
            sx={{
              color: "#104145",
              backgroundColor: "#EBD28D",
              textTransform: "none",
              padding: "0.313rem 1.375rem",
              fontWeight: 400,
              borderRadius: "8px",
              fontSize: { xs: "18px", md: "22px" },
              boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.1)",
              display: "block",
              mx: { xs: "auto", md: 0 },
              marginBottom: { md: "4rem" },
            }}
            onClick={handleStartPlanningToday}
          >
            Start Planning Today
          </Button>
        </Box>
      </Box>

      {/* Right Section Image */}
      <Box
        sx={{
          width: { xs: "100%", md: "50%" },
          height: { xs: "260px", sm: "360px", md: "70vh" },
          overflow: "hidden",
        }}
      >
        <img
          src={YourGuide}
          alt="your-guide-img"
          style={{
            width: "100%",
            height: "100%",
            objectFit: "cover",
          }}
        />
      </Box>
    </Box>
  );
}
